/* global $ */

export default {
  logError(errorMessage) {
    window.vp.instrumentation.logError(`Upload from GPP Test - ${errorMessage}`);
  },

  touchFeature(featureId) {
    $.get(`/studio4/touchfeaturevalue?featureId=${encodeURIComponent(featureId)}`);
  },

  get activeFeatureValues() {
    return window.utag_data.ActiveFeatureValues;
  },
};
